import React, { FC } from "react";
import classes from "./UI_ITOModuleDocumentsList.module.css";
import {
  getDocumentKkbStatusProperties,
  DocumentToSign,
  DocumentKkb,
  DocumentType,
} from "../../store/slice/requestAppSlise/requestAppSlise";

import { DownloadOutlined } from "@ant-design/icons";

import { UI_ModuleDocuments } from "../indexUI";
import { DownloadingFiles } from "../../utils/utilities/Downloads";

/* Лист документов (просмотр) на правой панели */
interface UI_ITOModuleDocumentsListProps {
  docs: DocumentToSign[] | DocumentType<DocumentKkb>[];
  applicationBankId: number;
}

const getDocumentTitleDown = (documentDto: DocumentToSign) => {
  if (documentDto.type_doc.type === "ANKETA") {
    return "Анкета.pdf";
  }
  if (documentDto.type_doc.name) {
    return documentDto.type_doc.name;
  }
  return "Документ не загружен";
};
const getDocumentTitleDownOther = (documentDto: DocumentType<DocumentKkb>) => {
  if (documentDto.type === "ANKETA") {
    return "Анкета.pdf";
  }
  if (documentDto.name) {
    return documentDto.name;
  }
  return "Документ не загружен";
};

export const UI_ITOModuleDocumentsList: FC<UI_ITOModuleDocumentsListProps> = ({
  docs,
  applicationBankId,
}) => {
  const onClickDownloadFile = async (doc: DocumentToSign) => {
    if (doc.type_doc.type === "ANKETA") {
      DownloadingFiles({
        url: `/auth/sign/client-anketa/${applicationBankId}/show`,
        fileName: `Анкета`,
      });
      return;
    }

    if (doc && doc.application_banks_id) {
      DownloadingFiles({
        url: `auth/applications/system-bank/create-data-to-bank/${doc.application_banks_id}/file/${doc.id}`,
        fileName: `${doc.name}`,
      });
      return;
    }
  };
  const onClickDownloadFileOther = async (doc: DocumentType<DocumentKkb>) => {
    if (doc.type === "ANKETA") {
      DownloadingFiles({
        url: `/auth/sign/client-anketa/${applicationBankId}/show`,
        fileName: `Анкета`,
      });
      return;
    }
    if (doc.document && doc.document.application_banks_id) {
      DownloadingFiles({
        url: `auth/applications/system-bank/create-data-to-bank/${doc.document.application_banks_id}/file/${doc.id}`,
        fileName: `${doc.name}`,
      });
      return;
    }
  };

  return (
    <>
      {docs?.map((documentDto: DocumentToSign | DocumentType<DocumentKkb>) => {
        if (Object.hasOwn(documentDto, "type_doc")) {
          const newDto = documentDto as DocumentToSign;
          return (
            <div
              key={newDto.name + newDto.id}
              className={
                newDto.type_doc.type === "ANKETA"
                  ? classes.documentCard
                  : classes.documentEmpty
              }
              onClick={() => onClickDownloadFile(newDto)}
            >
              <UI_ModuleDocuments
                title={getDocumentTitleDown(newDto)}
                titleDown={newDto.name}
                tag={getDocumentKkbStatusProperties(
                  !!newDto?.sign_file?.length
                )}
                icon={
                  <div className={classes.icon}>
                    <DownloadOutlined style={{ color: "#3C79FF" }} />
                    {"Скачать"}
                  </div>
                }
              />
            </div>
          );
        }
        if (Object.hasOwn(documentDto, "document")) {
          const newDto = documentDto as DocumentType<DocumentKkb>;
          return (
            <div
              key={newDto.name + documentDto.id}
              className={
                newDto.type === "ANKETA"
                  ? classes.documentCard
                  : classes.documentEmpty
              }
              onClick={() => onClickDownloadFileOther(newDto)}
            >
              <UI_ModuleDocuments
                title={getDocumentTitleDownOther(newDto)}
                titleDown={newDto.name}
                tag={getDocumentKkbStatusProperties(
                  !!newDto.document?.sign_file?.length
                )}
                icon={<DownloadOutlined  className={classes.iconDownLoad}/>}
              />
            </div>
          );
        }
      })}
    </>
  );
};
